import { createSelector } from '@reduxjs/toolkit';
import { ERoomType } from '../../../../packages/JsonQuery';
import { selectRoomType, selectDealType } from 'shared/selectors/jsonQuery';
import { selectRoomTypeLabel } from './selectRoomTypeLabel';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { isRentDailyOnMain } from 'shared/utils/page/isRentDailyOnMain';
import { EPageType } from 'shared/types/page';
import { TButtonSize } from 'shared/types/filters';

interface IRoomType {
  label: string;
  value: ERoomType;
}

const ROOM_TYPES: IRoomType[] = [
  { label: '1-комнатная', value: ERoomType.FlatOneRoom },
  { label: '2-комнатная', value: ERoomType.FlatTwoRooms },
  { label: '3-комнатная', value: ERoomType.FlatThreeRooms },
  { label: '4-комнатная', value: ERoomType.FlatFourRooms },
  { label: '5-комнатная', value: ERoomType.FlatFiveRooms },
  { label: '6-комнатная', value: ERoomType.FlatManyRooms },
  { label: 'Студия', value: ERoomType.Studio },
  { label: 'Свободная планировка', value: ERoomType.FlatFreeLayout },
];

export const selectRoomTypeFilter = createSelector(
  [selectRoomType, selectRoomTypeLabel, selectDealType, selectPageType, selectIsInlineFiltersRedesigned],
  (
    value,
    label,
    dealType,
    pageType,
    isFiltersRedesignEnabled,
  ): {
    label: string;
    value: typeof value;
    options: typeof ROOM_TYPES;
    visible: boolean;
    size: TButtonSize;
  } => ({
    label: label || 'Комнатность',
    value,
    options: ROOM_TYPES,
    visible: !(isFiltersRedesignEnabled && isRentDailyOnMain(dealType, pageType)),
    size: isFiltersRedesignEnabled && pageType === EPageType.MAIN && !!label ? 'small' : 'default',
  }),
);
